export default __webpack_public_path__ + "static/media/index.85558dca.less";